<template>
  <div>
    <div class="text-xs-right">
      <v-btn icon @click="$emit('close')"><v-icon>close</v-icon></v-btn>
    </div>
    <div>
      <div v-if="loading" class="text-xs-center py-4">
        <v-progress-circular indeterminate color="primary" size="70"></v-progress-circular>
      </div>
      <div v-else>
        <div class="text-xs-center">
          <div style="display: flex; align-items: center; justify-content: center">
            <span class="mr-3" style="font-size: 39px">
              <i
                v-if="detailData.app == 'facebook'"
                style="color: #4267b2"
                class="fab fa-facebook-square"
              />
              <em v-else style="color: #00c300" class="fab fa-line" />
            </span>
            <span style="font-size: 19px; color: grey"> {{ detailData.channelname }}</span>
          </div>
        </div>
        <div class="px-5 pb-4">
          <v-card class="pa-4" color="#eee">
            <v-layout row wrap class="ma-0 my-3">
              <v-flex
                v-if="detailData.app == 'facebook'"
                xs6
                style="border-right: darkgrey solid 1px"
              >
                <div style="display: flex; align-items: center; justify-content: center">
                  <div class="mr-3">
                    <v-btn large icon color="primary">
                      <em style="font-size: 25px" class="fas fa-thumbs-up white--text" />
                    </v-btn>
                  </div>
                  <div>
                    <div style="font-weight: bold; font-size: 19px">
                      {{ numberFormat(likes) }}
                    </div>
                    <div class="primary--text">Likes</div>
                  </div>
                </div>
              </v-flex>
              <v-flex v-else xs6 style="border-right: darkgrey solid 1px">
                <div style="display: flex; align-items: center; justify-content: center">
                  <div class="mr-3">
                    <v-btn large icon color="primary">
                      <em style="font-size: 25px" class="fas fa-users white--text" />
                    </v-btn>
                  </div>
                  <div>
                    <div style="font-weight: bold; font-size: 19px">
                      {{ numberFormat(followers) }}
                    </div>
                    <div class="primary--text">Inbox</div>
                  </div>
                </div>
              </v-flex>
              <v-flex xs6>
                <div
                  v-if="detailData.app == 'facebook'"
                  style="display: flex; align-items: center; justify-content: center"
                >
                  <div class="mr-3">
                    <v-btn large icon color="primary">
                      <em style="font-size: 25px" class="fas fa-users white--text" />
                    </v-btn>
                  </div>
                  <div>
                    <div style="font-weight: bold; font-size: 19px">
                      {{ numberFormat(followers) }}
                    </div>
                    <div class="primary--text">Followers</div>
                  </div>
                </div>
                <div v-else style="display: flex; align-items: center; justify-content: center">
                  <div class="mr-3">
                    <v-btn large icon color="primary">
                      <em style="font-size: 25px" class="fas fa-broadcast-tower white--text" />
                    </v-btn>
                  </div>
                  <div>
                    <div style="font-weight: bold; font-size: 19px">
                      {{ numberFormat(quota) }}
                    </div>
                    <div class="primary--text">Broadcast Quota</div>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
          <div v-if="detailData.app == 'line'" class="form-control mt-3">
            <label for>Webhook Url</label>
            <div class="row" style="margin-bottom: 0">
              <div class="col s12 m9">
                <textarea
                  ref="shareLink"
                  v-model="webhookUrl"
                  class="form-control"
                  style="resize: vertical; min-height: 90px; background: #eee"
                  onclick="this.select()"
                  readonly="true"
                ></textarea>
              </div>
              <div class="text-xs-left col s12 m3">
                <a
                  v-clipboard:copy="webhookUrl"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  href="javascript:void(0);"
                  class="btn btn-outline-red"
                  style="position: relative"
                >
                  <span class="fas fa-copy"></span>
                  {{ $t('copy') }}
                  <transition
                    enter-active-class="animated fadeInUp"
                    leave-active-class="animated fadeOut"
                  ></transition>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import config from '@/config'
import { mapGetters } from 'vuex'
export default {
  props: ['detailData'],
  data() {
    return {
      webhookUrl: '',
      loading: false,
      likes: 0,
      quota: 0,
      followers: 0,
      showCopy: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.getData()
    this.webhookUrl = `${config.webhookUrl}webhookline?facebookpageid=${this.detailData.channelid}`
  },
  methods: {
    onCopy: function () {
      let vm = this
      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 1000)
    },
    onError: function () {},
    async getData() {
      this.loading = true

      var getAll = [this.getFollowers()]
      if (this.detailData.app == 'facebook') {
        getAll.push(this.getLikes())
      } else {
        getAll.push(this.getLineQuota())
      }
      await Promise.all(getAll)
      this.loading = false
    },
    getFollowers() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          channelId: this.detailData.channelid
        }
        api.powerbuyGetFollowers(data, (err, response) => {
          this.followers = response.data[0].followers
          resolve()
        })
      })
    },
    getLikes() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          channelId: this.detailData.channelid
        }
        api.powerbuyGetFacebookLike(data, (err, response) => {
          this.likes = response.data[0].likes
          resolve()
        })
      })
    },
    getLineQuota() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          channelId: this.detailData.channelid
        }
        api.powerbuyGetLineQuota(data, (err, response) => {
          this.quota = response.data[0].quotaAvailable
          resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/powerbuy/Management/ChannelDetail.vue